// materials should be id'd by the 1-indexed order in this array (ie, first element has ID 1)
export const KNOWN_MATERIALS = [
  'Seed',
  'Nut',
  'Achene',
  'Bract+enclosed achene',
  'Burr',
  'Capsule',
  'Caryopsis',
  'Caryopsis+palea',
  'Caryopsis+palea+lemma',
  'Cypsela',
  'De-pulped drupe',
  'Seed excluding wings',
  'Diaspore',
  'Seed excluding seed-coat',
  'Seed excluding endocarp',
  'Five united, one-seeded carpels',
  'Fruit',
  'Fruiting calyx',
  'Seed+endocarp',
  'Involucre',
  'Nutlet',
  'Samara',
  'Seed cleaned of pulp and wings (where appropriate)',
  'Seed excluding pericarp',
  'Seed+part of pericarp',
  'Seed+pericarp',
  'Seed+pericarp excluding wings',
  'Seed+pericarp+calyx',
  'Seed+pericarp+dewinged involucre',
  'Seed+pericarp+perianth',
  'Pod',
  'Seed+ovary tissues (e.g. achene)',
  'Seed+calyx',
  'Seed excluding pappus',
  'Germinule',
  'Pyrene',
  'Embryo+endosperm',
  'Seed cleaned of pulp',
  'Seed excluding "dispersal structures"',
  'Seed including "dispersal structures"',
]
